import { ChangeEvent, useState } from 'react';
import { ValueFieldProps } from '@sitecore-jss/sitecore-jss-react-forms';
import classNames from 'classnames';

import { useEnvConfig } from 'src/contexts/EnvConfigContext';
import { useFormTheme } from 'src/contexts/FormTheme/FormThemeContext';
import { useUserDevices } from 'src/hooks/useUserDevices';
import { UserDevicesSelectorViewModel } from 'src/types/userDevicesSelector';

import JabraSelect from '../Shared/JabraSelect';

const UserDevicesSelector: React.FC<ValueFieldProps<UserDevicesSelectorViewModel>> = (props) => {
  const { field, isValid } = props;
  const { id, name } = field.valueField;
  const { required } = field.model;

  const envConfig = useEnvConfig();

  const [selectedPsn, setSelectedPsn] = useState<string>('');

  const FieldValidationErrors = props.fieldValidationErrorsComponent;
  const Label = props.labelComponent;

  const { primaryTextColor } = useFormTheme();

  const { data, isLoading, error } = useUserDevices({
    baseUrl: envConfig.publicTieredServicePortalBaseUrl,
  });

  const devices = data.devices || [];

  const handleChange = (event: ChangeEvent<HTMLSelectElement>) => {
    const newValue = event.target.value;
    setSelectedPsn(newValue);
    props.onChange(name, newValue, isValid, []);
  };

  const getPlaceholderText = () => {
    if (isLoading) return 'Loading devices...';
    if (error) return 'Error loading devices';
    return 'Select a device';
  };

  return (
    <div className={classNames('flex flex-col', primaryTextColor)}>
      {!!Label && <Label {...props} />}
      <JabraSelect
        id={id}
        name={name}
        value={selectedPsn}
        jssMetadata={props}
        required={required}
        onChange={handleChange}
        disabled={isLoading || !!error}
        aria-describedby={error ? `${id}-error` : undefined}
      >
        <option value="">{getPlaceholderText()}</option>
        {!isLoading &&
          !error &&
          devices.map((device) => (
            <option key={device.psn} value={JSON.stringify(device)}>
              {device.title} • PSN: {device.psn}
            </option>
          ))}
      </JabraSelect>
      {error && (
        <p id={`${id}-error`} role="alert" className="text-sm text-error">
          {error.message}
        </p>
      )}
      {!!FieldValidationErrors && <FieldValidationErrors {...props} />}
    </div>
  );
};

export default UserDevicesSelector;
